import type { paths } from '@pba/types-openapi-client';
import type { EventPrivacy, ProgramEventType } from 'models';
import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { EventContentObjectDataObject } from 'models/service';

export type DefaultProgramEventRequestData = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  event_type: ProgramEventType;
  events_files?: EntityReferenceRailsRequestData[];
  featured_in_channels?: boolean;
  program_id?: string;
  program_topic_id?: string;
  publish_at?: Date;
  show_in_channels?: boolean;
  tag_ids?: string[];
  view_permission: EventPrivacy;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
} & CommonProgramEventRequestData;

export type ProgramEventRequestData = DefaultProgramEventRequestData;

type AttendeesRequestData =
  paths['/v3/event_users/{id}']['patch']['requestBody']['content']['application/json']['event'];

type CommonProgramEventRequestData = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  allow_guest?: boolean;
  community_id?: string;
  cover_photo?: EntityReferenceRailsRequestData;
  duplicate_invitees_from?: string;
  end_time: Date;
  html_content?: string;
  name: string;
  start_time: Date;
  text_content?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
} & AttendeesRequestData;

export const createProgramEvent = async (event: ProgramEventRequestData) =>
  apiClient.post<EventContentObjectDataObject, ApiClientResponse<EventContentObjectDataObject>>(routes.events.create, {
    event,
  });
